import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-map-search",
  "use": "icon-icon-map-search-usage",
  "viewBox": "0 0 15.145 15.145",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.145 15.145\" id=\"icon-icon-map-search\"><defs><style>#icon-icon-map-search .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M11.882,9.867a5.99,5.99,0,1,0-2.016,2.015l4.064,4.064,2.015-2.016Zm-5.107.606a3.695,3.695,0,1,1,3.7-3.693,3.7,3.7,0,0,1-3.7,3.693Z\" transform=\"translate(-0.8 -0.8)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol